<template>
  <div class="wizard-form">
    <h2 v-if="item.pageTitle" class="intro">
      {{ item.pageTitle }}
    </h2>
    <p v-if="item.pageDescription" class="intro">
      {{ item.pageDescription }}
    </p>
    <div class="main-container">
      <div class="content-container">
        <div class="content">
          <wizard-dynamic
            v-if="item.introContentPath"
            class="intro-container"
            :template="introContent"
          />
          <wizard-triage
            v-if="item.triage"
            :triage-full="triageFull"
            :triage-basic="triageBasic"
            :item="item"
            @wizardTriageCompleted="triageCompleted"
          />
          <wizard-dynamic
            v-if="item.contentPath && !item.triage"
            class="form-container"
            :template="formContent"
          />
        </div>
      </div>
      <div v-if="teaser" class="teaser-container">
        <wizard-teaser :teaser="teaser" />
      </div>
    </div>
  </div>
</template>

<script>
import { client } from '@/helpers/http'

import WizardDynamic from './WizardDynamic'
import WizardTeaser from './WizardTeaser'
import WizardTriage from './WizardTriage'

export default {
  name: 'WizardForm',
  components: {
    WizardTeaser,
    WizardTriage,
    WizardDynamic,
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    active: Boolean,

    triageFull: {
      type: Object,
      default: () => ({}),
    },

    triageBasic: {
      type: Object,
      default: () => ({}),
    },

    teaser: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    formContent: '',
    introContent: '',
  }),

  watch: {
    active: {
      async handler(active) {
        if (!active) {
          return
        }
        const { item } = this
        if (item.introContentPath) {
          const result = await client().get(item.introContentPath + '.html')
          this.introContent = this.disableComponentLoader(result.data)
        }

        // if there is a content and no triage, load content directly
        if (item.contentPath && !item.triage) {
          return this.loadContent()
        }
      },
      immediate: true,
    },
  },

  methods: {
    async loadContent() {
      const result = await client().get(this.item.contentPath + '.html')

      this.formContent = this.disableComponentLoader(result.data)
    },
    triageCompleted() {
      if (this.item.contentPath) {
        this.loadContent()
      }
    },
    disableComponentLoader(markup) {
      /* Remove attributes to resolve components with component loader
       * Because nested components loaded by the component loader lead to errorneous or missing components
       * `data-dotcom-manual-load` is just a replacement string without handler */
      return markup.replaceAll(
        'data-dotcom-component',
        'data-dotcom-manual-load',
      )
    },
  },
}
</script>

<style scoped>
>>> .container {
  padding-left: 0;
  padding-right: 0;
}

h2 {
  margin-bottom: 15px;

  &.intro {
    color: var(--c-primary-neutral-3);
  }
}

p {
  &.intro {
    color: var(--c-primary-neutral-3);
  }
}

.main-container {
  margin-top: 30px;

  .san-ovp-entry {
    margin-bottom: 10px !important;
  }

  .content-container {
    margin-bottom: 10px;

    .content {
      border-radius: 5px;
      background-color: var(--c-primary-neutral-3);
      padding: 30px;
    }
  }

  .teaser {
    border-radius: 5px;
    background-color: var(--c-primary-neutral-3);
    padding: 30px;
  }

  @media (--lg) {
    display: flex;

    .content-container {
      width: 35%;
      margin-right: 20px;
      flex-grow: 1;
    }

    .teaser-container {
      width: 35%;
    }
  }
}
</style>
